module.exports = __webpack_public_path__ + "assets/f74fad3e1110563da0edd37a47365637.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/bg1.png
// module id = 377
// module chunks = 1